import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetPlacementError } from '../bet-placement-error';

export class DoubleBetPrevention extends BetPlacementError {
    constructor() {
        super();
        this.type = PlacementErrorType.DoubleBetPrevention;
        this.priority = 1; // Double bet prevention displayed after all errors.
    }
}
